import { CrownOutlined, PlusOutlined, UserOutlined } from "@ant-design/icons";
import styled from "@emotion/styled";
import {
  Avatar,
  Button,
  Card,
  Col,
  Divider,
  Form,
  FormInstance,
  Input,
  Modal,
  Row,
  Space,
  Spin,
  Tag,
  Typography,
  message,
} from "antd";
import { Dispatch, FC, SetStateAction, useState } from "react";
import {
  AddAddressDataInput,
  AgentByIdResponse,
  MasterDistrictData,
  MasterProvinceData,
  MasterSubDistrictData,
  UpdateAddressDataInput,
} from "services/interface";
import {
  useGetLocationType,
  useGetMasterDistrict,
  useGetMasterSubDistrict,
  useGetTransportType,
} from "hooks/useMasterData";
import { AddressData } from "components/ManageAgent/CreateAgent/AddressComponents/interface/address.interface";
import UpdateAgentAddressForm from "components/ManageAgent/CreateAgent/AddressComponents/UpdateAgentAddressForm";
import CreateAgentAddressForm from "components/ManageAgent/CreateAgent/AddressComponents/CreateAgentAddressForm";
import AddressCardList from "./AddressCardList";
import { useAddAddressData, useUpdateAddressData } from "hooks/useAgents";
import Meta from "antd/es/card/Meta";
import noImage from "assets/images/no-image.png";
import { useNavigate } from "react-router-dom";
import { QueryClient } from "@tanstack/react-query";
import {
  useGetDeliveryPoint,
  useGetParkingTransportDistrictType,
  useGetParkingTransportProvinceType,
  useGetParkingTransportType,
} from "hooks/useShipping";
import { useAppSelector } from "store";
import { useGetTransportationTypeByFactory } from "hooks/useFactory";

interface MainCreateAgentAddressProps {
  dataAgent: AgentByIdResponse | undefined;
  form: FormInstance;
  masterProviceData: any;
  setDataAddress: Dispatch<SetStateAction<AddressData[]>>;
  dataAddress: AddressData[];
  handleRemoveItem: (index: any) => void;
  changeDefault: (id: string) => void;
  searchOption?: boolean;
  addNow?: boolean;
  refetch: () => void;
  radioSelect?: string;
}

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};

const MainCreateAgentAddress: FC<MainCreateAgentAddressProps> = ({
  dataAgent,
  form,
  searchOption,
  masterProviceData,
  setDataAddress,
  handleRemoveItem,
  dataAddress,
  refetch,
  changeDefault,
  radioSelect,
}) => {
  const navigate = useNavigate();
  const queryClient = new QueryClient();

  const { mutate: AddAddress, isPending: AddAddressIsLoading } =
    useAddAddressData();
  const { mutate: UpdateAddress, isPending: UpdateAddressIsLoading } =
    useUpdateAddressData();
  const [provinceId, setProvinceId] = useState<number>(0);
  const [districtId, setDistrictId] = useState<number>(0);

  const factoryId = useAppSelector(
    (state) => state.auth.profile?.user?.role?.ref_id
  );

  const { data: masterTransportData, isPending: transportLoading } =
    useGetTransportType();
  const { data: masterLocationData, isPending: locationLoading } =
    useGetLocationType();
  const { data: masterDistrictData, isPending: districtLoading } =
    useGetMasterDistrict(provinceId);
  const { data: masterSubDistrictData, isPending: subDistrictLoading } =
    useGetMasterSubDistrict(districtId);

  const limit = 40;
  const offset = 0;
  const search = "";

  const {
    data: deliveryPoint,
    isPending,
    refetch: getDPrefetch,
  } = useGetDeliveryPoint({
    district_id: districtId,
    province_id: provinceId,
    limit: limit,
    offset: offset,
    search: search,
    //factory_id: factoryId || "",
  });

  const [selectedLocation, setSelectedLocation] = useState<string>("");
  const [selectedLocationEdit, setSelectedLocationEdit] = useState<string>("");
  const [addressIdSelected, setAddressIdSelected] = useState<string>("");

  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(false);

  const [formAddress] = Form.useForm();
  const [formEdit] = Form.useForm();
  const showDrawer = () => {
    setOpen(true);
  };

   // const factoryId = useAppSelector((state) => state.auth.profile?.user?.role?.ref_id);
  const { data: TransportationTypeData } = useGetTransportationTypeByFactory(factoryId ?? '');

  // จังหวัดจุดส่งฟรี
  const { data: masterProviceFreeData, isLoading: proviceLoading } =
    useGetParkingTransportProvinceType({
      transport_type:
        selectedLocation || selectedLocationEdit || "transport_free",
      factory_id: factoryId || "",
    });

  // อำเภอฟรี
  const { data: masterDistrictFreeData, isLoading: districtFreeLoading } =
    useGetParkingTransportDistrictType({
      transport_type:
        selectedLocation || selectedLocationEdit || "transport_free",
      province_id: provinceId,
      factory_id: factoryId || "",
    });

  const {
    data: deliveryFreePoint,
    isLoading,
    refetch: getDFreePrefetch,
  } = useGetParkingTransportType({
    district_id: districtId,
    province_id: provinceId,
    transport_type:
      selectedLocation || selectedLocationEdit || "transport_free",
    factory_id: factoryId || "",
  });

  const showEdit = async (id: string) => {
    const dataEdit = dataAddress.find(
      (item: AddressData) => item.address_id === id || item.temp_id === id
    );
    setAddressIdSelected(dataEdit?.address_id ?? dataEdit?.temp_id ?? "");
    const selectedTransport = TransportationTypeData?.data?.find(
      (item) => item.key === dataEdit?.transport_type
    );
    setSelectedLocationEdit(selectedTransport?.key ?? "");
    setProvinceId(dataEdit?.province_id ?? 0);
    setDistrictId(dataEdit?.district_id ?? 0);
    formEdit.setFieldsValue({
      transport: dataEdit?.transport_type,
      province_id_ship: dataEdit?.province_id,
      address_name: dataEdit?.address_name,
      address_telephone: dataEdit?.address_telephone,
      line_1: dataEdit?.line_1,
      line_2: dataEdit?.line_2,
      location_type: dataEdit?.location_type,
      district_id_ship: dataEdit?.district_id,
      sub_district_id_ship: dataEdit?.sub_district_id,
      zip_code_ship: dataEdit?.post_code,
      address_detail: dataEdit?.address_remark,
      parking_id: dataEdit?.parking_id,
      remark: dataEdit?.remark,
    });

    setEdit(true);
  };

  const onCloseEdit = () => {
    setEdit(false);
    formEdit.resetFields();
    setSelectedLocationEdit("");
  };

  const onClose = () => {
    setOpen(false);
    formAddress.resetFields();
    setSelectedLocation("");
  };

  const handleSearchAddress = () => {};

  const onEdit = (values: any) => {
    const dataInput: UpdateAddressDataInput = {
      id: addressIdSelected,
      ref_id: dataAgent?.id || "",
      ref_type: dataAgent?.ref_type || "",
      transport_type: values?.transport,
      address_type: "ship",
      address_name: values?.address_name,
      address_telephone: values?.address_telephone,
      address_detail: values?.address_detail,

      line_1: values?.line_1,
      line_2: values?.line_2,
      district_id: values?.district_id_ship,
      province_id: values?.province_id_ship,
      sub_district_id: values?.sub_district_id_ship,
      post_code: values?.zip_code_ship,
      // address_taxno: values?.address_taxno,
      parking_id: values?.parking_id,
      location_type: values?.location_type,
      remark: values?.remark,
    };
    UpdateAddress(dataInput, {
      onSuccess: async (res) => {
        if (res.status === "success") {
          message.success("แก้ไขที่อยู่ลูกค้าสำเร็จ");
          await queryClient.refetchQueries({
            queryKey: ["load_contacts"],
            type: "active",
          });
          refetch();
        } else {
          message.error(`แก้ไขที่อยู่ลูกค้าไม่สำเร็จ: ${res.error_message}`);
        }
      },
      onError: (error) => {
        message.error(`แก้ไขที่อยู่ลูกค้าไม่สำเร็จ: ${error.message}`);
      },
    });
    // const editedAddress = dataAddress.map((address: AddressData) => {
    //   if (address.address_id === addressIdSelected || address.temp_id === addressIdSelected) {
    //     return {
    //       ...address,
    //       transport_type: values.transport,
    //       address_name: values.address_name,
    //       address_telephone: values.address_telephone,
    //       address_detail: values.address_detail,
    //       district_id: values.district_id_ship,
    //       district_name: selectedDistrict?.name_th,
    //       province_id: values.province_id_ship,
    //       province_name: selectedProvince?.name_th,
    //       sub_district_id: values.sub_district_id_ship,
    //       sub_district_name: selectedSubDistrict?.name_th,
    //       post_code: values.zip_code_ship,
    //       address_taxno: values.address_taxno,
    //       line_1: values.line_1,
    //       line_2: values.line_2,
    //       location_type: values.location_type,
    //       address_text: values.address_text,
    //     };
    //   }
    //   return address;
    // });
    // setDataAddress(editedAddress);
    setEdit(false);
    // console.log('update')
  };
  const onFinish = (values: any) => {
    // const selectedDistrict = masterDistrictData?.find((item: MasterDistrictData) => item.id === values.district_id_ship);
    // const selectedSubDistrict = masterSubDistrictData?.find((item: MasterSubDistrictData) => item.id === values.sub_district_id_ship);
    // const selectedProvince = masterProviceData?.find((item: MasterProvinceData) => item.id === values.province_id_ship);

    // const data: AddressData = {
    //   temp_id: generateUUIDTemporay(),
    //   transport_type: values?.transport,
    //   address_type: 'ship',
    //   address_name: values?.address_name,
    //   address_telephone: values?.address_telephone,
    //   address_detail: values?.address_detail,

    //   line_1: values?.line_1,
    //   line_2: values?.line_2,
    //   district_id: values?.district_id_ship,
    //   district_name: selectedDistrict?.name_th,
    //   province_id: values?.province_id_ship,
    //   province_name: selectedProvince?.name_th,
    //   sub_district_id: values?.sub_district_id_ship,
    //   sub_district_name: selectedSubDistrict?.name_th,
    //   post_code: values?.zip_code_ship,
    //   address_taxno: values?.address_taxno,
    //   location_type: values?.location_type,
    // }

    const dataInput: AddAddressDataInput = {
      ref_id: dataAgent?.id || "",
      ref_type: dataAgent?.ref_type || "",
      transport_type: values?.transport,
      address_type: "ship",
      address_name: values?.address_name,
      address_telephone: values?.address_telephone,
      address_detail: values?.address_detail,

      line_1: values?.line_1,
      line_2: values?.line_2,
      district_id: values?.district_id_ship,
      province_id: values?.province_id_ship,
      sub_district_id: values?.sub_district_id_ship,
      post_code: values?.zip_code_ship,
      // address_taxno: values?.address_taxno,
      parking_id: values?.parking_id,
      location_type: values?.location_type,
      remark: values?.remark,
    };
    AddAddress(dataInput, {
      onSuccess: (res) => {
        if (res.status === "success") {
          message.success("สร้างที่อยู่ลูกค้าสำเร็จ");
          queryClient.refetchQueries({
            queryKey: ["load_contacts"],
            type: "all",
          });
          refetch();
        } else {
          message.error(`สร้างที่อยู่ลูกค้าไม่สำเร็จ: ${res.error_message}`);
        }
      },
      onError: (error) => {
        message.error(`สร้างที่อยู่ลูกค้าไม่สำเร็จ: ${error.message}`);
      },
    });

    // setDataAddress([...dataAddress, data]);
    onClose();
    // console.log('add')
  };

  return (
    <>
      <FormWrapper>
        {dataAgent && (
          <>
            <StyledCard
              style={{
                width: "500px",
                backgroundColor: "#efefef",
                margin: "10px",
                padding: "10px",
              }}
            >
              <Meta
                avatar={
                  <Avatar
                    shape="square"
                    size={76}
                    src={dataAgent.image_url || noImage}
                  />
                }
                description={
                  <Space direction="vertical" size={0}>
                    <Space direction="horizontal" size={0}>
                      <Typography.Text strong>{dataAgent.name}</Typography.Text>
                      <Typography.Text className="text-order-agent-name">
                        {" "}
                        {dataAgent && dataAgent.alias
                          ? `(${dataAgent.alias})`
                          : ""}
                      </Typography.Text>
                    </Space>
                    <Space direction="horizontal" size={0}>
                      <Typography.Text>ประเภท:</Typography.Text>
                      <Typography.Text>
                        {/* {"  "} {dataAgent?.ref_type ?? ""}{" "} */}
                        ลูกค้า
                      </Typography.Text>
                    </Space>
                    <Space direction="horizontal" size={0}>
                      <Typography.Text>ที่อยู่:</Typography.Text>
                      <Typography.Text>
                        {" "}
                        {dataAgent?.address_contact[0]?.location_text ??
                          ""}{" "}
                      </Typography.Text>
                    </Space>
                    <Space direction="horizontal" size={0}>
                      <Typography.Text>เบอร์โทรศัพท์:</Typography.Text>
                      <Typography.Text>
                        {" "}
                        {dataAgent.telephone_number ?? ""}
                      </Typography.Text>
                    </Space>
                    <Space direction="horizontal" size={0}>
                      <Typography.Text>Email:</Typography.Text>
                      <Typography.Text>
                        {" "}
                        {dataAgent.email ?? ""}
                      </Typography.Text>
                    </Space>
                    <Space direction="horizontal" size={0}>
                      {/* <Typography.Text>{items.email}</Typography.Text> */}
                    </Space>
                  </Space>
                }
              />
              <div className="ant-card-actions">
                <ButtonSmall
                  type="primary"
                  onClick={() => {
                    if (dataAgent.ref_type === "agent") {
                      navigate(`/manage-agent/update-agent/${dataAgent.id}`);
                    } else {
                      navigate(`/manage-agent/update-retail/${dataAgent.id}`);
                    }
                  }}
                  target="_blank"
                >
                  ดูข้อมูล
                </ButtonSmall>
              </div>
              <div className="ant-card-vip">
                {dataAgent.is_vip && (
                  <Tag color="red">
                    <CrownOutlined /> VIP
                  </Tag>
                )}
                {dataAgent.is_connected && (
                  <Tag color="blue" style={{ margin: 0 }}>
                    <UserOutlined /> ลูกค้า
                  </Tag>
                )}
              </div>
            </StyledCard>
            <Divider />
          </>
        )}

        <HeadWrapper>
          <Typography.Text
            style={{
              fontWeight: 600,
              whiteSpace: "nowrap",
            }}
            underline
          >
            ที่อยู่ในการจัดส่ง
          </Typography.Text>
          <ButtonWrapper>
            {searchOption && (
              <Space.Compact>
                <Input
                  style={{ height: "32px" }}
                  placeholder="ค้นหาที่อยู่จัดส่ง"
                />
                <StyledButton type="primary" onClick={handleSearchAddress}>
                  ค้นหา
                </StyledButton>
              </Space.Compact>
            )}

            <StyledButton
              type="primary"
              onClick={showDrawer}
              disabled={dataAgent?.id ? false : true}
            >
              <PlusOutlined /> สร้างที่อยู่จัดส่ง
            </StyledButton>
          </ButtonWrapper>
        </HeadWrapper>
        <Row style={{ backgroundColor: "#FFFFFFFF" }}>
          <Col span={24}>
            <AddressCardList
              dataAddress={dataAddress}
              form={form}
              setDataAddress={setDataAddress}
              handleRemoveItem={handleRemoveItem}
              showEdit={showEdit}
              changeDefault={changeDefault}
              radio={radioSelect ? radioSelect : ""}
            />
          </Col>
        </Row>
      </FormWrapper>
      <Modal
        title="สร้างที่อยู่จัดส่ง"
        open={open}
        maskClosable={false}
        onCancel={onClose}
        // width={1000}
        // footer={null}
        style={{ top: 20 }}
        onOk={() => {
          //onClose(); // ปิด Modal
          // เรียกใช้ callback function ที่ส่งเข้ามา
          formAddress.submit(); // ตัวอย่างการ submit form
        }}
        cancelText="ยกเลิก"
        okText="ตกลง"
      >
        <Form form={formAddress} {...formItemLayout} onFinish={onFinish}>
          <CreateAgentAddressForm
            form={formAddress}
            masterLocationData={masterLocationData}
            masterTransportData={TransportationTypeData?.data}
            masterProviceData={masterProviceData}
            masterDistrictData={masterDistrictData}
            masterSubDistrictData={masterSubDistrictData}
            selectedLocation={selectedLocation}
            setSelectedLocation={setSelectedLocation}
            setProvinceId={setProvinceId}
            setDistrictId={setDistrictId}
            deliveryPointData={deliveryPoint}
            masterProviceFreeData={masterProviceFreeData}
            masterDistrictFreeData={masterDistrictFreeData}
            deliveryFreePoint={deliveryFreePoint}
          />
        </Form>
      </Modal>
      {/* Update Modal */}
      <Modal
        title="แก้ไขที่อยู่จัดส่ง"
        open={edit}
        maskClosable={false}
        onCancel={onCloseEdit}
        style={{ top: 20 }}
        onOk={() => {
          formEdit.submit();
        }}
        cancelText="ยกเลิก"
        okText="ตกลง"
      >
        <Form form={formEdit} {...formItemLayout} onFinish={onEdit}>
          <UpdateAgentAddressForm
            form={formEdit}
            masterLocationData={masterLocationData}
            masterTransportData={TransportationTypeData?.data}
            masterProviceData={masterProviceData}
            masterDistrictData={masterDistrictData}
            masterSubDistrictData={masterSubDistrictData}
            selectedLocation={selectedLocationEdit}
            setSelectedLocation={setSelectedLocationEdit}
            setProvinceId={setProvinceId}
            setDistrictId={setDistrictId}
            deliveryPointData={deliveryPoint}
            masterProviceFreeData={masterProviceFreeData}
            masterDistrictFreeData={masterDistrictFreeData}
            deliveryFreePoint={deliveryFreePoint}
          />
        </Form>
      </Modal>
    </>
  );
};

export default MainCreateAgentAddress;

const StyledButton = styled(Button)`
  margin-right: 5px;
`;
const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  height: 100%;
`;

const HeadWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 0px 10px 0px 10px;
  margin-bottom: 10px;
  & > :first-child {
    flex: 3;
  }

  & > :last-child {
    flex: 7;
    display: flex;
    justify-content: flex-end;
  }
`;

const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffffff;
`;

const StyledCard = styled(Card)`
  position: relative;
  .ant-card-actions {
    position: absolute;
    bottom: 0;
    right: 0;
    margin: 5px;
    z-index: 10; // Ensure this is higher than surrounding elements
  }
  .ant-card-vip {
    position: absolute;
    top: 0;
    right: 0;
    margin: 5px;
    z-index: 10; // Ensure this is higher than surrounding elements
  }
`;

const ButtonSmall = styled(Button)`
  font-size: 12px;
  padding: 3px;
  width: 60px;
  height: 20px;
  color: #fff !important;
  display: flex;
  align-items: center;
  justify-content: center;
`;

// const VIPButton = styled(Button)`
//   position: absolute;
//   top: 10px;
//   right: 90px; // Adjusted to place it next to the Plus button
//   background-color: gold;
//   color: black;
//   border: none;

//   &:hover, &:focus {
//     background-color: goldenrod;
//     color: black;
//   }
// `;
